import {
    IGetPayloadMessage,
    IPayloadMessageResult,
    IPayloadSms,
    IPayloadSmsResult,
} from '../interfaces/IAnimal';
import { IApiListResult, IApiResult } from '../interfaces/IGeneral';
import { IUpdatePayload } from '../interfaces/IGeneral';
import { IMessages } from '../shortMessageService/ISms';
import { sendDirectMessageUrl } from './apiEndpoints';

import ApiBase from './ApiBase';

class ShortMessageApi extends ApiBase {
    getPayloadMessages = (messagesToGet: IGetPayloadMessage[]) => {
        return this.postList<IPayloadMessageResult>(`${sendDirectMessageUrl}/GetPayloadMessages`, {
            MessagesToGet: messagesToGet,
        });
    }

    sendPayloadMessages = (messages: IPayloadSms[]) => {
        return this.postList<IPayloadSmsResult>(`${sendDirectMessageUrl}/SendPayloadMessages`, {
            PayloadSmsMessages: messages,
        });
    }

    sendDirectMessage(payload?: any) {
        return this.postList<IMessages>(`${sendDirectMessageUrl}/SendDirectMessage`, payload);
    }

    getMessagesList(from: string, to: string) {
        return this.getList<IMessages>(`${sendDirectMessageUrl}/ListSentMessages/from/${from}/to/${to}`);
    }

    updateMessage(guid: string, payload: IUpdatePayload<IMessages>) {
        return this.patch<IApiResult<IMessages>>(`${sendDirectMessageUrl}/${guid}`, payload);
    }

    cancelMessage(guid: string) {
        return this.delete<IApiResult<IMessages>>(`${sendDirectMessageUrl}/${guid}`);
    }

    sendEventMessages(payload: { Content: string, PhoneNumbers: string[] }) {
        return this.postList<IMessages>(`${sendDirectMessageUrl}/SendEventMessages`, payload);
    }
}

export default new ShortMessageApi();
